import React from 'react'
import {
    useReactTable,
    getCoreRowModel,
    getSortedRowModel,
} from '@tanstack/react-table'

import TableHeader from '../shared/TableHeader'
import TableBody from '../shared/TableBody'

const Table = ({
    name,
    columns,
    data,
    loading,
    initialSort,
    initialSortDesc,
    containerClass,
    isClickable,
}) => {
    const initialSorting =
        initialSort && initialSortDesc
            ? [{ id: initialSort, desc: initialSortDesc }]
            : []
    const table = useReactTable({
        columns,
        data,
        initialState: {
            sorting: initialSorting,
            columnVisibility: { FacilityID: false },
        },
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        sortDescFirst: false,
    })
    return (
        <>
            <div
                className={`container table-container is-small ${containerClass ? containerClass : null}`}
            >
                <table className="table is-striped is-fullwidth is-hoverable explorerTable">
                    <TableHeader headerGroups={table.getHeaderGroups()} />
                    <TableBody
                        {...{
                            rows: table.getRowModel().rows,
                            loading,
                            isClickable,
                        }}
                    />
                </table>
            </div>
        </>
    )
}

export default Table
